import "GIS/Map/Layer/WMS";
/** @namespace Geo.GIS.Layer */
NS("GIS.Map.Layer");
/**
 * @class
 * @extends GIS.Map.Layer.WMS
 */
GIS.Map.Layer.GeoanalitikaAgro = Class(GIS.Map.Layer.WMS,
    /** @lends Geo.GIS.Layer.GeoanalitikaAgro.prototype */
    {
		filter_: {},

        initialize: function(map, options) {
            this.Parent(map, _.merge(options || {}, {
                url: '/geoanalitika_agro/',
                tileSize: [256, 256],
                params: {
					...options.filter_,
                    format: 'image/png',
                    transparent: true,
                    version: '1.3.0',
                }
            }));
        },
		/**
		 * @param {Object|Function} filter
		 */
		filter(filter) {
			this.filter_ = filter;
			this.layer.filter(filter);
			this.layer.source.updateParams(filter);

		}
    }
);